import { Navigate } from 'react-router'

import { useInitData } from '../../../hooks'
import { getRentalPortalDefaultSubsectionName } from '../RentalPortal.utils'

function RentalPortalIndexRedirect() {
  const { sections } = useInitData()

  return (
    <Navigate replace to={getRentalPortalDefaultSubsectionName(sections)} />
  )
}

export default RentalPortalIndexRedirect
